shvenergy.imagewithinfopointers = (function ($) {
	"use strict";

	function init() {

		// Function from David Walsh: http://davidwalsh.name/css-animation-callback
		function whichTransitionEvent() {
			var t,
				el = document.createElement("fakeelement");

			var transitions = {
				"transition": "transitionend",
				"OTransition": "oTransitionEnd",
				"MozTransition": "transitionend",
				"WebkitTransition": "webkitTransitionEnd"
			}

			for (t in transitions) {
				if (el.style[t] !== undefined) {
					return transitions[t];
				}
			}
		}

		var transitionEvent = whichTransitionEvent();

		var allInfoPoints = $(".infopoint");
		var allButtons = $(".infopoint__button");
		var allInfoTexts = $(".infopoint__text");

		function closeAllInfoPointers() {

			$(".infopoint__button.active").addClass("close");
			removeClone();

			setTimeout(function () {
				allButtons.removeClass("active close").attr("aria-expanded", "false");
				allInfoTexts.removeClass("active");
				setTimeout(function () {
					allInfoPoints.removeClass("active");
				   
				}, 700);

            }, 700);

			$("html").removeClass("mobileInfoPointActive");
		}

		function removeClone() {
			$(".infopointtext-offcanvas.active").one(transitionEvent, function (event) {
				$(".infopointtext-offcanvas").remove();
				allInfoPoints.removeClass("active");
				allButtons.removeClass("active close").attr("aria-expanded", "false");
            }).removeClass("active");

			$("html").removeClass("mobileInfoPointActive");
		}

		var closeButton = $("<button>", {
			"type": "button",
			"text": "",
			"class": "infopointtext-offcanvas__close"
		}).on("click", function (e) {
			e.stopPropagation();
			removeClone();
		});

		var mobileInfopointText = $("<div>", {
			"class": "infopointtext-offcanvas"
		});

		function handleMobileInfoText(currentButton, parent) {
			let iconColor = parent.attr("icon-color");

			mobileInfopointText.removeClass("white black");
			closeButton.removeClass("white black");
			mobileInfopointText.addClass(iconColor);
			closeButton.addClass(iconColor);

			$(".infopointtext-offcanvas").remove();

			var closeButtonClone = closeButton.clone(true);

			var clone = $(this).next("div").clone();

			clone.prepend(closeButtonClone);

			var content = $(".infopoint.active").find(".infopoint__text").html();

			var l = mobileInfopointText.clone();
			l.prepend(closeButtonClone);
			l.append(content);
            $("body").append(l);
			$("html").addClass("mobileInfoPointActive");

			setTimeout(function () {
				l.addClass("active");
			}, 10);

		}

		function handleDesktopInfoText(clickedButton) {
			var currentButton = $(clickedButton);
			var parent = currentButton.parent();

			setTimeout(function () {
				allButtons.not(currentButton).removeClass("active close").attr("aria-expanded", "false");

				setTimeout(function () {
                    allInfoPoints.not(parent).removeClass("active");
                    currentButton.blur();
				}, 100);

			}, 100);
		}

		allButtons.on("click", function (e) {
			e.stopPropagation();

			var currentButton = $(this);
			var parent = currentButton.parent();
			var textPanel = currentButton.next(".infopoint__text");
			var text = currentButton.find(".hover-text").text();
			shvenergy.tracking.trackEvent("Image with infopoints", "Infopoint click", text);

			if (parent.hasClass("active")) {
				closeAllInfoPointers();
			} else {
				allButtons.not(currentButton).removeClass("active close").attr("aria-expanded", "false");
				allInfoTexts.not(textPanel).removeClass("active");

				parent.addClass("active");
				currentButton.addClass("active").attr("aria-expanded", "true");

				if (window.matchMedia("(max-width: 750px)").matches) {
					handleMobileInfoText(currentButton, parent);
				} else {

					textPanel.addClass("active");
					handleDesktopInfoText(currentButton);
				}
			}
		});

		if (!('ontouchstart' in window || 'onmsgesturechange' in window)) {
			allButtons.on("mouseenter", function () {
				$(this).addClass("mouseover");
			}).on("mouseleave", function () {
				$(this).removeClass("mouseover");
			});
		}

		$(document).on("click", function (e) {
			if ($(e.target).closest(".infopoint").length === 0 && $(e.target).closest(".infopointtext-offcanvas").length === 0) {
                closeAllInfoPointers();
			}
		});

        function onImageWithInfopointersResize() {
            // Store the window width
            var windowWidth = $(window).width();
            // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
            if ($(window).width() != windowWidth) {

                // Update the window width for next time
                windowWidth = $(window).width();

                // Do stuff here
                closeAllInfoPointers();

            }

            // Otherwise do nothing

			
		}

		$(window).on("resize", onImageWithInfopointersResize);
    }

    init();

})(jQuery);